<template>
    <div class="sales">
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/pop/xsyb/xsyb1.jpg" class="steps step1" v-if="status==1">
			<img src="../../assets/images/pop/xsyb/xsyb2.jpg" class="steps step2" v-if="status==2" >
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <breadcrumb :routerList="[{to:'/chanp/salesTable',title:'销售样表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="产品大类">
						    <brselect category="product_level" :v="q.oneLid" v-model="q.oneLid" :clearable="true"
						              style="width:100%"/>
						</el-form-item>
						<el-form-item label="产品状态">
						    <brselect category="chainStatus" :v="q.chainStatus" v-model="q.chainStatus" :clearable="true"
						              style="width:100%"/>
						</el-form-item>
						<el-form-item label="产品型号">
						    <el-input v-model="q.promodelLike" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="产品编码">
						    <el-input v-model="q.prodcodeLike" placeholder=""></el-input>
						</el-form-item>
					</div>
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="公司名称">
									<brselect category="xsyb_gongsi" :v="q.companycode" v-model="q.companycode" :clearable="true"
											  style="width:100%"/>
								</el-form-item>

                                <el-form-item label="链群">
									<brselect category="xsyb_lianqun" :v="q.lianqun" v-model="q.lianqun" :clearable="true"
											  style="width:100%"/>
								</el-form-item>
                                <el-form-item label="子链群">
									<brselect category="xsyb_lianqunchild" :v="q.lianqunchild" v-model="q.lianqunchild" :clearable="true"
											  style="width:100%"/>
								</el-form-item>
                                <el-form-item label="是否服务产品">
                                    <el-select v-model="q.isFw"
                                               placeholder="请选择"
                                               clearable>
                                        <el-option label="是" value="1"></el-option>
                                        <el-option label="否" value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                                
							</div>
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="产地" prop="factory">
                  <brselect category="factory" :v="q.chandidata" :showcode="true"
                            v-model="q.chandidata" :multiple="true" :collapse-tags="true" clearable></brselect>
                </el-form-item>
              </div>
						</div>
					</el-collapse-transition>
                    
                    <!--<el-form-item label="型号经理编号">
                        <el-input v-model="q.userCode" placeholder="" style="width:1.9rem"></el-input>
                    </el-form-item>-->
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" style="border:none;" @click="query">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
						<el-button
						        class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
						        @click="createdemand" v-auth="'xsyb_xinzeng'">新增销售样表
						</el-button>
					</div>
				</div>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table
                @selection-change="handleSelectionChange"
                ref="multipleTable"
                :data="tableData"
                :border="true"
                style="width: 100%"
				max-height="460"
                >
                <el-table-column
                    type="selection"
                    width="40"
                    :label="all"
                    >
                </el-table-column>
                <el-table-column
                    fixed
                    type="index"
                    label="#"
                    width="40">
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.$index+1}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="prodseries"
                    label="产品大类"
                    width="100"
                    :show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.prodseries}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="procategory"
                    label="二级分类"
                    width="110"
                    :show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.procategory}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="promodel"
                    label="产品型号"
                    min-width="180"
                    :show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}" style="text-align: left;">
                            {{scope.row.promodel}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="prodcode"
                    label="产品编码"
                    width="120"
                    :show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.prodcode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="prodstatus"
                        label="状态"
                        :show-overflow-tooltip="true"
                        width="70"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.prodstatus | dictname('prodstatus')}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="chainStatus"
                        label="状态码"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.chainStatus}}|{{scope.row.chainStatus | dictname('chainStatus')}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="have6858"
                    width="160"
                    label="二类是否覆盖6858"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.have6858 | dictname('permit')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="have6840"
                    width="160"
                    label="二类是否覆盖6840"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.have6840 | dictname('permit')}}
                        </div>
                    </template>
                </el-table-column>
                <!--<el-table-column
                    prop="permit"
                    width="70"
                    label="是否需要三类资质"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.permit | dictname('permit')}}
                        </div>
                    </template>
                </el-table-column>-->
                <el-table-column
                    prop="have6854"
                    width="160"
                    label="三类是否覆盖6854"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.have6854 | dictname('permit')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="three6840"
                        width="160"
                        label="三类是否覆盖6840"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.three6840 | dictname('permit')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="areaList"
                        label="区域"
                        :show-overflow-tooltip="true"
                        width="150"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
							<span v-for="(item,index) in scope.row.areaList"
                                  :key="index"
                                  :value="item"
                                  :class="{'redclass':scope.row.seriestrue == 0}">
							    {{item | dictname('YlSalesArea_chanpin')}}
							</span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="companycode"
                        label="公司名称"
                        width="180"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;" :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.companycode | dictname('xsyb_gongsi')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="factory"
                        label="产地"
                        width="60"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;" :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.factory}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="channelList"
                    label="渠道专供"
                    width="100"
					:show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.channelList"
                             :key="index"
                             :value="item"
                             :class="{'redclass':scope.row.seriestrue == 0}">
                            {{item | dictname('sales_region')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="类别"
                    width="70"
					:show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.sort}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="protype"
                    label="型号属性"
                    width="90"
					:show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.protype}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="userCode"
                    label="型号经理"
                    width="100"
					:show-overflow-tooltip="true"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.userCode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="validperiod"
					:show-overflow-tooltip="true"
                    label="有效期"
                    width="100"
                    >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{ scope.row.validperiod?scope.row.validperiod.substr(0,10):'' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="xiaoe"
                        label="是否计入销额"
                        width="120"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.xiaoe | dictname('xiaoe_jishu')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jishu"
                        label="是否计入基数"
                        width="120"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.jishu | dictname('xiaoe_jishu')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="lianqun"
                        label="链群"
						:show-overflow-tooltip="true"
                        width="90"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.seriestrue == 0}">
                            {{scope.row.lianqun | dictname('xsyb_lianqun')}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="lianqunchild"
                        label="子链群"
                        width="90"
                        :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div :class="{'redclass':scope.row.lianqunchild == 0}">
                            {{scope.row.lianqunchild | dictname('xsyb_lianqunchild')}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="isFw"
                        label="是否服务产品"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        <span v-if="scope.row.isFw == '1'">是</span>
                        <span v-if="scope.row.isFw == '0'">否</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                    prop="ldate"
                    label="更新时间"
					:show-overflow-tooltip="true"
                    width="160"
                    >
                    <template slot-scope="scope">
                        <div class="tanboxs">
                            <span v-if="usertype==1" :class="{'redclass':scope.row.seriestrue == 0}">{{ scope.row.ldate}}</span>
                            <span @click="mousetable(scope.row)" v-if="usertype!=1"
                                  :class="{'redclass':scope.row.seriestrue == 0}">{{ scope.row.ldate}}</span>
                            <el-dialog
                                    title=""
                                    top="30vh"
                                    :visible.sync="dialogVisible"
                                    :fullscreen="false"
                                    width="35%"
                                    :modal="false"
                                    :before-close="handleClose">
                                <div class="tanBox">
                                    <el-table
                                        :data="tableDatas"
                                        style="width: 100%">
                                        <el-table-column
                                            prop="updatecode"
                                            label="更新人编号"
                                            width="130"
                                            :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                            prop="updatename"
                                            label="更新人名称"
                                            width="190"
                                            :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                            prop="updatetime"
                                            label="更新时间">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-dialog>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180"
                    fixed="right"
                    v-auth="'xsyb_caozuo'"
                    >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
							<el-button
							    type="text"
							    size="small"
							    class="h-tableLink h-btn" @click="below(scope.row)"
							    v-if="scope.row.chainStatus == 'PA' ||scope.row.chainStatus == 'EM' "
							    v-auth="'xsyb_caozuo'"
							>
                                订单终止
							</el-button>
							<!--<el-button
							    type="text"
							    size="small"
							    class="h-tableLink h-btn"
							    v-if="scope.row.prodstatus == '3'"
							    v-auth="'xsyb_caozuo'">
							    订单已终止
							</el-button>-->
							<el-button
							    type="text"
							    size="small"
							    class="h-tableLink h-btn" @click="toChange(scope.row)"
							    v-auth="'xsyb_caozuo'">
							    修改
							</el-button>
							<el-button
							        type="text"
							        size="small"
							        class="h-tableLink h-btn" @click="toDelete(scope.row)"
							        v-auth="'xsyb_caozuo'">
							    删除
							</el-button>
						</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-ss" v-if="scope.row.prodstatus == '1'||scope.row.prodstatus == '4'" title="下市" @click="below(scope.row)"></span>
							<span class="l-operationlist br-operation-xs" v-if="scope.row.prodstatus == '2' || scope.row.prodstatus == '3'" title="上市" @click="Listed(scope.row)"></span>
							<span class="l-operationlist br-operation-xg" title="修改" @click="toChange(scope.row)"></span>
							<span class="l-operationlist br-operation-delete" title="删除" @click="toDelete(scope.row)"></span>
						</div> -->

                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                <div>
                    <el-button
                        class="h-btn h-formBtn h-bgblueQ"
                        icon="h-el-icon h-el-icon-import"
                        style="margin-left:-20px;"
                        @click="exportExcel" v-auth="'xsyb_daochu'">
                        批量导出
                    </el-button>
                    <el-button
                        class="h-btn h-formBtn h-bgblueQ"
                        icon="h-el-icon h-el-icon-export"
                        @click="uploaddownexcelflagbtn"
                        v-auth="'xsyb_daoru'">
                        批量导入
                    </el-button>
                    <uploaddownexcel
                        :visible.sync="uploaddownexcelflag"
                        v-if="uploaddownexcelflag"
                        clsname="samplelistImportExcel"
                        :startrow="3"
                        @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-pagination2" style="display:inline-block">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        name: "productManage",
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
               /* gly:false,*/
                next:true,
                toshow:'salesTable3',
                checked:true,
				showOrhide:false,
				status:1,
                //导入Excel
                uploaddownexcelflag: false,
                usertype: null,
                tableDatas: [],
                dialogVisible: false,
                isflags: false,
                //表单
                all: '全部',
                q: {
                    oneLid:null,
                    prodcodeLike:null,
                    usercode:null,
                    promodelLike:null,
                    chainStatus:null,
                    companycode:null,
                    lianqun:null,
                    lianqunchild:null,
                    chandidata:null,
                    ids: [],
                    channelList: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表格
                multipleSelection: [],
                tableData: [],
            }
        },
        created() {
			this.showzhezhao()
            this.query();
            this.usertype = this._user.usertype;

        },
        mounted() {

        },

        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            closeIt(){
                this.showOrhide = false;
                if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						this.showOrhide = false;
					})
                }else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
                console.log(i)
                if(this.status ==1){
					this.status = 2;
                }else if(this.status ==2){
                    if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							this.showOrhide = false;
						})
                    }else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							this.showOrhide = false;
						})
					}


                }
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //更新操作
            mousetable(value) {
                ss.salesList.selectUpdate(value.id).then(rd => {
                    this.tableDatas = rd;
                    this.dialogVisible = true;
                })
            },
           //关闭弹出框
            handleClose(v) {
                v()
            },
            //重置检索项
            resetData() {
                this.q.oneLid = null;
                this.q.chainStatus = null;
                this.q.promodelLike = null;
                this.q.prodcodeLike = null;
                this.q.companycode = null;
                this.q.userCode=null;
                this.q.lianqun =null;
                this.q.chandidata = null;
                this.q.lianqunchild = null
            },
            query() {
                //this.gly = this.$store.getters.hasRole("swyl_xsyb_gly,swyl_admin");
                ss.salesList.selectPage(this.q).then(rd => {

                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //订单终止
            below(value) {
              if (value.chainStatus == "订单终止") {
                this.$message.error("产品已订单终止");
              } else {
                console.log(value.chainStatus,"value.chainStatus");
                this.$msg.confirm("确认订单终止?", () => {
                  if(value.chainStatus != 'EM'){
                    this.$message.error("非制造终止不能下市");
                    return null;
                  }else{
                    ss.salesList.below(value.id).then(rd => {
                      this.$msg.msgs(rd.msg);
                      this.query();
                    });
                  }
                  });
              }
            },
            //上市
           /* Listed(value) {
                if (value.prodstatus == "上市") {
                    this.$message.error("产品已上市");
                } else {
                    this.$msg.confirm("确认上市?", () => {
                        ss.salesList.Listed(value.id).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                }
            },*/
            //修改销售样表
            toChange(value) {
                this.$router.push({path: "/chanp/salesTablebj", query: {id: value.id}});
            },
            //删除销售样表
            toDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.salesList.toDelete(value.id).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                });
            },
            //明细导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    this.q.ids.push(element.id);
                });
                updownfile.down("/api/swyl/v1/salesamplelist/bscSalesSamplelist/downloadExcel", this.q, "post", 'data');
            },
            //新增销售样表
            createdemand() {
                this.$router.push({path: "/chanp/salesTablehx"});
            },
        },

    }
</script>
<style scoped>
    .sales > .h-piece, .h-mrt30 {
        margin: 20px;
    }
    .redclass {
        color: red;
    }
</style>
<style>
    .tanboxs .el-dialog__headerbtn {
        display: none;
    }

    .tanboxs .el-dialog .el-dialog__body {
        padding: 10px;
    }
    .tanboxs .el-dialog {
        box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
        border: 1px solid #ccc;
        border-radius: 10px;
    }
    .tanboxs .el-table thead th {
        padding: 0;
    }
    .tanboxs .el-dialog__header {
        padding: 0;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0;
			right: 0;
		}
		.step2{
			top: 0;
			right: 0;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>

